import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const user = JSON.parse(localStorage.getItem("user"));

export const loginUser = createAsyncThunk(
  "user/loginUser",
  async (userCredentials) => {
    try {
      const request = await axios.post(
        `${BASE_URL}/backend/user/login`,
        userCredentials
      );

      const response = await request.data;
      localStorage.setItem("user", JSON.stringify(response));
      return response;
    } catch (error) {
      console.error("Login failed:", error);
    }
  }
);

export const logout = createAsyncThunk("user/logout", async (requestBody) => {
  const request = await axios.post(
    `${BASE_URL}/backend/user/logout`,
    { refreshToken: requestBody }
  );
  const response = await request.data;
  localStorage.removeItem("user");
  return response;
});

const initialState = user
  ? { isLoggedIn: true, loading: true, user, error: null }
  : { isLoggedIn: false, user: null, loading: false, error: null };

const userSlice = createSlice({
  name: "user",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.user = null;
        state.isLoggedIn = false;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isLoggedIn = true;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.user = null;
        state.isLoggedIn = false;

        if (action.message === "Request failed with status code 401") {
          state.error = "Access Denied! Invalid Credentials";
        } else if (action.message === "Request failed with status code 400") {
          state.error = action.message;
        } else {
          state.error = action.message;
        }
      })
      .addCase(logout.fulfilled, (state, action) => {
        state.loading = false;
        state.user = null;
        state.isLoggedIn = false;
        state.error = null;
      });
  },
});

export default userSlice.reducer;
